    <!--  ERRORS  -->
    @if(!supressErrors()){
        @if( obj()?.errorsSig(); as errors){
            @if(useSingleAlert()){
                @if(hasErrorsSig()) {
                    <div class="alert kf-element kf-danger-red py-2 pe-1 mb-{{bottomMargin()}} {{additionalAlertClasses()}}">
                        <i class="fas fa-exclamation-triangle me-1"></i>
                        @for (prop of props(); track prop) {
                            <span>{{errors[prop]}} </span>
                        }
                    </div>
                }
            }
            @else{
                @for (prop of props(); track prop) {
                    @if (!!errors[prop]) {
                        <div class="alert kf-element kf-danger-red py-2 pe-1 mb-{{bottomMargin()}} {{additionalAlertClasses()}}">
                            <i class="fas fa-exclamation-triangle me-1"></i><span>{{errors[prop]}}</span>
                        </div>
                    }
                }
            }
        }
    }
    
    <!--  WARNINGS  -->
    @if( obj()?.warningsSig(); as warnings){
        @if(useSingleAlert()){
            @if(hasWarningsSig()) {
                <div class="alert kf-element kf-warning-yellow py-2 pe-1 mb-{{bottomMargin()}} {{additionalAlertClasses()}}">
                    <i class="fas fa-flag me-1"></i>
                    @for (prop of props(); track prop) {
                        <span>{{warnings[prop]}} </span>
                    }
                </div>
            }
        }
        @else{
            @for (prop of props(); track prop) {
                @if (!!warnings[prop]) {
                    <div class="alert kf-element kf-warning-yellow py-2 pe-1 mb-{{bottomMargin()}} {{additionalAlertClasses()}}">
                        <i class="fas fa-flag me-1"></i><span>{{warnings[prop]}}</span>
                    </div>
                }
            }
        }
    }
